// extracted by mini-css-extract-plugin
export default {"numberBox":"Range_numberBox__4OQrp","soonTag":"Range_soonTag__iOmEh"};